exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sidebar .menu-nav .menu-item-click a .icon i:before {\n  font-size: 28px;\n  color: #ffffff;\n}", ""]);

// exports
